var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"stationStatus",class:_vm.computedClasses,attrs:{"title":_vm.status}},[(!_vm.hideText)?_c('span',[_vm._v(_vm._s(_vm.status === "SUSPENDEDEV" ? "IDLE" : _vm.status))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }